// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.f_spacer_base {
  flex-grow: 0;
  flex-shrink: 0;
}

.f_spacer_grow {
  flex-grow: 1;
  flex-shrink: 0;
}

.f_spacer_single_value_fb {
  flex-basis: var(--f_spacer_size_mobile);
}

.f_spacer_variable_fb {
  flex-basis: var(--f_spacer_size_mobile);
}

@media screen and (min-width: 768px) {
  .f_spacer_variable_fb {
    flex-basis: var(--f_spacer_size_tablet);
  }
}

@media screen and (min-width: 1024px) {
  .f_spacer_variable_fb {
    flex-basis: var(--f_spacer_size_desktop);
  }
}

@media screen and (min-width: 1440px) {
  .f_spacer_variable_fb {
    flex-basis: var(--f_spacer_size_xlarge);
  }
}

@media screen and (min-width: 1920px) {
  .f_spacer_variable_fb {
    flex-basis: var(--f_spacer_size_xxlarge);
  }
}

.f_spacer_single_value_min_width {
  min-width: var(--f_spacer_size_mobile);
}

.f_spacer_variable_min_width {
  min-width: var(--f_spacer_size_mobile);
}

@media screen and (min-width: 768px) {
  .f_spacer_variable_min_width {
    min-width: var(--f_spacer_size_tablet);
  }
}

@media screen and (min-width: 1024px) {
  .f_spacer_variable_min_width {
    min-width: var(--f_spacer_size_desktop);
  }
}

@media screen and (min-width: 1440px) {
  .f_spacer_variable_min_width {
    min-width: var(--f_spacer_size_xlarge);
  }
}

@media screen and (min-width: 1920px) {
  .f_spacer_variable_min_width {
    min-width: var(--f_spacer_size_xxlarge);
  }
}

.f_spacer_single_value_min_height {
  min-height: var(--f_spacer_size_mobile);
}

.f_spacer_variable_min_height {
  min-height: var(--f_spacer_size_mobile);
}

@media screen and (min-width: 768px) {
  .f_spacer_variable_min_height {
    min-height: var(--f_spacer_size_tablet);
  }
}

@media screen and (min-width: 1024px) {
  .f_spacer_variable_min_height {
    min-height: var(--f_spacer_size_desktop);
  }
}

@media screen and (min-width: 1440px) {
  .f_spacer_variable_min_height {
    min-height: var(--f_spacer_size_xlarge);
  }
}

@media screen and (min-width: 1920px) {
  .f_spacer_variable_min_height {
    min-height: var(--f_spacer_size_xxlarge);
  }
}
`, "",{"version":3,"sources":["webpack://./../../core/web/src/slate/spacing/native-styles.css"],"names":[],"mappings":"AAAA;EAEE,YAAY;EACZ,cAAc;AAChB;;AAEA;EAEE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,wCAAwC;EAC1C;AACF","sourcesContent":[".f_spacer_base {\n  -moz-box-flex: 0;\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n\n.f_spacer_grow {\n  -moz-box-flex: 1;\n  flex-grow: 1;\n  flex-shrink: 0;\n}\n\n.f_spacer_single_value_fb {\n  flex-basis: var(--f_spacer_size_mobile);\n}\n\n.f_spacer_variable_fb {\n  flex-basis: var(--f_spacer_size_mobile);\n}\n\n@media screen and (min-width: 768px) {\n  .f_spacer_variable_fb {\n    flex-basis: var(--f_spacer_size_tablet);\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .f_spacer_variable_fb {\n    flex-basis: var(--f_spacer_size_desktop);\n  }\n}\n\n@media screen and (min-width: 1440px) {\n  .f_spacer_variable_fb {\n    flex-basis: var(--f_spacer_size_xlarge);\n  }\n}\n\n@media screen and (min-width: 1920px) {\n  .f_spacer_variable_fb {\n    flex-basis: var(--f_spacer_size_xxlarge);\n  }\n}\n\n.f_spacer_single_value_min_width {\n  min-width: var(--f_spacer_size_mobile);\n}\n\n.f_spacer_variable_min_width {\n  min-width: var(--f_spacer_size_mobile);\n}\n\n@media screen and (min-width: 768px) {\n  .f_spacer_variable_min_width {\n    min-width: var(--f_spacer_size_tablet);\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .f_spacer_variable_min_width {\n    min-width: var(--f_spacer_size_desktop);\n  }\n}\n\n@media screen and (min-width: 1440px) {\n  .f_spacer_variable_min_width {\n    min-width: var(--f_spacer_size_xlarge);\n  }\n}\n\n@media screen and (min-width: 1920px) {\n  .f_spacer_variable_min_width {\n    min-width: var(--f_spacer_size_xxlarge);\n  }\n}\n\n.f_spacer_single_value_min_height {\n  min-height: var(--f_spacer_size_mobile);\n}\n\n.f_spacer_variable_min_height {\n  min-height: var(--f_spacer_size_mobile);\n}\n\n@media screen and (min-width: 768px) {\n  .f_spacer_variable_min_height {\n    min-height: var(--f_spacer_size_tablet);\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .f_spacer_variable_min_height {\n    min-height: var(--f_spacer_size_desktop);\n  }\n}\n\n@media screen and (min-width: 1440px) {\n  .f_spacer_variable_min_height {\n    min-height: var(--f_spacer_size_xlarge);\n  }\n}\n\n@media screen and (min-width: 1920px) {\n  .f_spacer_variable_min_height {\n    min-height: var(--f_spacer_size_xxlarge);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
